import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import { getRequest, putRequest } from '../../requestUtils';
import ProjectLoadingIndicator from '../ProjectDetails/ProjectLoadingIndicator';
var models = ['area_of_expertise', 'therapeutic_area', 'disease_code', 'therapy', 'regulatory_pathway', 'development_phase', 'degree', 'language', 'skill', 'accreditation'];
var formStep = 'expertise-priority';
var SuggestedMustHavesModal = /*#__PURE__*/function (_Component) {
  function SuggestedMustHavesModal(props) {
    var _this;
    _classCallCheck(this, SuggestedMustHavesModal);
    _this = _callSuper(this, SuggestedMustHavesModal, [props]);
    _defineProperty(_this, "togglePriority", function (model, id) {
      return function () {
        var _this$state = _this.state,
          priorityExpertiseTags = _this$state.priorityExpertiseTags,
          nonPriorityExpertiseTags = _this$state.nonPriorityExpertiseTags;
        var pri = _objectSpread({}, priorityExpertiseTags);
        var non = _objectSpread({}, nonPriorityExpertiseTags);
        var inPri = pri["".concat(model, "_ids")].includes(id);
        if (inPri) {
          // demote
          pri["".concat(model, "_ids")] = pri["".concat(model, "_ids")].filter(function (x) {
            return x !== id;
          });
          non["".concat(model, "_ids")] = [].concat(_toConsumableArray(non["".concat(model, "_ids")]), [id]);
        } else {
          // promote
          pri["".concat(model, "_ids")] = [].concat(_toConsumableArray(pri["".concat(model, "_ids")]), [id]);
          non["".concat(model, "_ids")] = non["".concat(model, "_ids")].filter(function (x) {
            return x !== id;
          });
        }
        _this.setState({
          priorityExpertiseTags: pri,
          nonPriorityExpertiseTags: non
        });
      };
    });
    _defineProperty(_this, "handleSave", function () {
      var _this$props = _this.props,
        csrfToken = _this$props.csrfToken,
        projectResourceId = _this$props.projectResourceId,
        onSaved = _this$props.onSaved;
      var _this$state2 = _this.state,
        priorityExpertiseTags = _this$state2.priorityExpertiseTags,
        nonPriorityExpertiseTags = _this$state2.nonPriorityExpertiseTags,
        localMode = _this$state2.localMode,
        expertisePicklists = _this$state2.expertisePicklists;
      var projectAttributes = {};
      models.forEach(function (model) {
        projectAttributes["non_priority_".concat(model, "_ids")] = nonPriorityExpertiseTags["".concat(model, "_ids")];
        projectAttributes["priority_".concat(model, "_ids")] = priorityExpertiseTags["".concat(model, "_ids")];
      });
      _this.setState({
        saving: true
      });
      if (!localMode && projectResourceId) {
        putRequest("/projects/".concat(projectResourceId, "?form_step=").concat(formStep), {
          project: projectAttributes
        }, csrfToken).then(function () {
          _this.setState({
            saving: false
          });
          onSaved();
        })["catch"](function () {
          return _this.setState({
            saving: false
          });
        });
      } else {
        _this.setState({
          saving: false
        });
        onSaved({
          priorityExpertiseTags: priorityExpertiseTags,
          nonPriorityExpertiseTags: nonPriorityExpertiseTags,
          expertisePicklists: expertisePicklists
        });
      }
    });
    _this.state = {
      loading: true,
      expertisePicklists: {},
      priorityExpertiseTags: null,
      nonPriorityExpertiseTags: null,
      notApplicable: [],
      saving: false,
      localMode: false
    };
    return _this;
  }
  _inherits(SuggestedMustHavesModal, _Component);
  return _createClass(SuggestedMustHavesModal, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var isOpen = this.props.isOpen;
      if (isOpen && !prevProps.isOpen) {
        this.loadData();
      }
    }
  }, {
    key: "loadData",
    value: function loadData() {
      var _this2 = this;
      var _this$props2 = this.props,
        projectResourceId = _this$props2.projectResourceId,
        initialExpertiseTags = _this$props2.initialExpertiseTags,
        initialPriorityExpertiseTags = _this$props2.initialPriorityExpertiseTags;
      this.setState({
        loading: true
      });
      if (projectResourceId) {
        getRequest("/projects/".concat(projectResourceId, "?form_step=").concat(formStep)).then(function (response) {
          var data = response.data;
          var picklists = data.expertise_picklists || {};
          var priority = data.priority_expertise_tags;
          // If non-priority is empty, seed it from general expertise_tags so users can toggle must-haves
          var seededNon = _objectSpread({}, data.non_priority_expertise_tags);
          var general = data.expertise_tags || {};
          ['area_of_expertise', 'therapeutic_area', 'disease_code', 'therapy', 'regulatory_pathway', 'development_phase', 'degree', 'language', 'skill', 'accreditation'].forEach(function (model) {
            if (!Array.isArray(seededNon["".concat(model, "_ids")]) || seededNon["".concat(model, "_ids")].length === 0) {
              seededNon["".concat(model, "_ids")] = Array.isArray(general["".concat(model, "_ids")]) ? _toConsumableArray(general["".concat(model, "_ids")]) : [];
            }
          });
          _this2.setState({
            expertisePicklists: picklists,
            priorityExpertiseTags: priority,
            nonPriorityExpertiseTags: seededNon,
            notApplicable: data.not_applicable,
            loading: false,
            localMode: false
          });
        });
      } else {
        // Local mode
        getRequest('/projects/expertise_picklists').then(function (_ref) {
          var data = _ref.data;
          var picklists = data.expertise_picklists || {};
          var seededNon = {};
          var seededPri = {};
          ['area_of_expertise', 'therapeutic_area', 'disease_code', 'therapy', 'regulatory_pathway', 'development_phase', 'degree', 'language', 'skill', 'accreditation'].forEach(function (model) {
            seededNon["".concat(model, "_ids")] = initialExpertiseTags && Array.isArray(initialExpertiseTags["".concat(model, "_ids")]) ? _toConsumableArray(initialExpertiseTags["".concat(model, "_ids")]) : [];
            seededPri["".concat(model, "_ids")] = initialPriorityExpertiseTags && Array.isArray(initialPriorityExpertiseTags["".concat(model, "_ids")]) ? _toConsumableArray(initialPriorityExpertiseTags["".concat(model, "_ids")]) : [];
          });
          _this2.setState({
            expertisePicklists: picklists,
            priorityExpertiseTags: seededPri,
            nonPriorityExpertiseTags: seededNon,
            notApplicable: [],
            loading: false,
            localMode: true
          });
        });
      }
    }
  }, {
    key: "renderModelGroup",
    value: function renderModelGroup(model, heading) {
      var _this3 = this;
      var _this$state3 = this.state,
        expertisePicklists = _this$state3.expertisePicklists,
        priorityExpertiseTags = _this$state3.priorityExpertiseTags,
        nonPriorityExpertiseTags = _this$state3.nonPriorityExpertiseTags;
      var picklist = expertisePicklists[model] || [];
      var selected = [].concat(_toConsumableArray(priorityExpertiseTags["".concat(model, "_ids")] || []), _toConsumableArray(nonPriorityExpertiseTags["".concat(model, "_ids")] || []));
      if (!selected.length) return null;
      return /*#__PURE__*/React.createElement("div", {
        className: "tag-container ".concat(model)
      }, /*#__PURE__*/React.createElement("div", {
        className: "expertise-tag-dropdown-heading"
      }, heading), /*#__PURE__*/React.createElement("div", {
        className: "tag-container-flex"
      }, selected.map(function (id) {
        var found = picklist.find(function (opt) {
          return opt.value === id;
        });
        if (!found) return null;
        var inPri = priorityExpertiseTags["".concat(model, "_ids")].includes(id);
        return /*#__PURE__*/React.createElement("span", {
          key: "".concat(model, "-").concat(id),
          role: "button",
          tabIndex: 0,
          className: inPri ? 'qualification-tag must-haves-tag' : 'expertise-tag-button',
          onClick: _this3.togglePriority(model, id)
        }, found.label);
      })));
    }
  }, {
    key: "renderContent",
    value: function renderContent() {
      var _this$state4 = this.state,
        loading = _this$state4.loading,
        priorityExpertiseTags = _this$state4.priorityExpertiseTags;
      if (loading || !priorityExpertiseTags) return /*#__PURE__*/React.createElement(ProjectLoadingIndicator, null);
      return /*#__PURE__*/React.createElement("div", {
        className: "style-guide project-expertise-container"
      }, /*#__PURE__*/React.createElement("h2", null, "Must-Have Qualifications"), /*#__PURE__*/React.createElement("p", null, "Select the requirements that candidates must have. Click a tag to toggle Must Have."), this.renderModelGroup('area_of_expertise', 'Functional Areas'), this.renderModelGroup('therapeutic_area', 'Therapeutic Areas'), this.renderModelGroup('disease_code', 'Diseases and Indications'), this.renderModelGroup('therapy', 'Product Technologies'), this.renderModelGroup('regulatory_pathway', 'Regulatory Pathways'), this.renderModelGroup('development_phase', 'Development Phases'), this.renderModelGroup('skill', 'Other Keywords / Skills'), this.renderModelGroup('language', 'Language'), this.renderModelGroup('degree', 'Highest Education'), this.renderModelGroup('accreditation', 'Certification'));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        isOpen = _this$props3.isOpen,
        onClose = _this$props3.onClose;
      var saving = this.state.saving;
      return /*#__PURE__*/React.createElement(Modal, {
        show: isOpen,
        onHide: onClose,
        dialogClassName: "expertise-priority-modal"
      }, /*#__PURE__*/React.createElement(Modal.Header, {
        closeButton: true
      }), /*#__PURE__*/React.createElement(Modal.Body, {
        className: "expertise-priority-modal-body"
      }, this.renderContent(), /*#__PURE__*/React.createElement("div", {
        className: "footer-buttons-container mt-4"
      }, /*#__PURE__*/React.createElement("button", {
        className: "btn btn-secondary button-back",
        onClick: onClose
      }, "Cancel"), /*#__PURE__*/React.createElement("button", {
        className: "btn btn-primary button-submit",
        onClick: this.handleSave,
        disabled: saving
      }, saving ? 'Saving…' : 'Save'))));
    }
  }]);
}(Component);
SuggestedMustHavesModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSaved: PropTypes.func.isRequired,
  projectResourceId: PropTypes.string,
  // optional in local mode
  csrfToken: PropTypes.string.isRequired,
  initialExpertiseTags: PropTypes.shape({}),
  initialPriorityExpertiseTags: PropTypes.shape({})
};
SuggestedMustHavesModal.defaultProps = {
  projectResourceId: null,
  initialExpertiseTags: undefined,
  initialPriorityExpertiseTags: undefined
};
export default SuggestedMustHavesModal;